module.exports = __webpack_public_path__ + "assets/img/solutions3.f9f2c598.png";